import React, { FunctionComponent } from 'react';

import 'common/notification-tray/desktop-alert-types/review-desktop-alert/review-desktop-alert-popup/ReviewDesktopAlertPopup.scss';

interface PopupProps {
    icon: JSX.Element;
    title: string;
    message: string;
    metrics?: JSX.Element;
    actions?: JSX.Element;
}

export const ReviewDesktopAlertPopup: FunctionComponent<PopupProps> = ({ icon, title, message, actions, metrics }) => {
    return (
        <div className="review-desktop-alert-popup">
            <span className="alert-icon-container">
                <span className="icon-background">{icon}</span>
            </span>
            <span className="alert-title-container">{title}</span>
            <span className="alert-message-container">{message}</span>
            {metrics ? <span className="alert-metrics-container">{metrics}</span> : null}
            {actions ? <div className="alert-actions-container">{actions}</div> : null}
        </div>
    );
};
